import React from 'react';

class ShipRequest extends React.Component {
    render() {
        return <div>
            {this.props.children}
        </div>
    }
}

export default ShipRequest;


// WEBPACK FOOTER //
// ./src/routes/shipRequest/index.js